module.exports = __webpack_public_path__ + "img/avbuilder_send.72cb3198.svg";